import { combineReducers, configureStore } from '@reduxjs/toolkit';
import { setupListeners } from '@reduxjs/toolkit/query';
import { developerApi } from '#/services/developerApi';
import { mapsApi } from '#/services/mapsApi';
import { NODE_ENVS } from '#/shared/constants';
import errorReducer from '#/shared/slices/error';
import locationReducer from '#/shared/slices/location';
import historyReducer from '#/shared/slices/history';
import transitTrackerReducer from '#/transit-tracker/slice';
import tripPlannerReducer from '#/trip-planner/slice';
import mapReducer from '#/map/slice';
import userReducer from '#/user/slice';
import type { SharedState } from '#/shared/types';
import rtkQueryErrorHandler from './middleware/rtk-query-error-handler';

const middlewareList = [
  developerApi.middleware,
  mapsApi.middleware,
  rtkQueryErrorHandler,
];

const store = configureStore({
  // the reducers here control the initial state of the app on reload,
  // some values are pulled from localStorage to rehydrate components
  reducer: {
    [developerApi.reducerPath]: developerApi.reducer,
    [mapsApi.reducerPath]: mapsApi.reducer,
    shared: combineReducers<SharedState>({
      error: errorReducer,
      location: locationReducer,
      history: historyReducer,
    }),
    transitTracker: transitTrackerReducer,
    tripPlanner: tripPlannerReducer,
    map: mapReducer,
    user: userReducer,
  },
  middleware: getDefaultMiddleware =>
    getDefaultMiddleware().concat(middlewareList),
  devTools: process.env.NODE_ENV !== NODE_ENVS.PROD,
});

// Required for refetchOnFocus/refetchOnReconnect behaviors
setupListeners(store.dispatch);

export default store;
export type RootState = ReturnType<typeof store.getState>;
